export const linearGradient = (colors: string, direction = 'to bottom') => `linear-gradient(${direction}, ${colors})`;
